import { enableBatching } from 'redux-batched-actions';

const initialState = [];

const reductions = {

    REPLACE_EVENTS: (state, action) => {
        return [].concat(action.payload);
    },

    UPDATE_EVENT: (state, action) => {
    	let foundEvent = false;
    	const updatedEvents = state.map(event => {
    		if (event.id === action.payload.id) {
                foundEvent = true;
    			return action.payload;
    		}
    		return event;
    	})
    	if (foundEvent) {
    		return updatedEvents;
    	}
        return [].concat(state, action.payload);
    }, 

    DELETE_EVENT: (state, action) => {
    	return state.filter(event => event.id !== action.payload.id);
    },
};

const eventsReducer = (state = initialState, action) => {
    if(action && action.type && reductions[action.type]) {
        return reductions[action.type](state, action)
    }
    return state;
};

export default enableBatching(eventsReducer);